export function removeObjectsWithEmptyFields(array, fields) {
  return array.filter((obj) => {
    return fields.some((field) => !!obj[field]);
  });
}
